<template>
  <v-btn
    :to="linkType == 'page' ? link : null"
    :href="linkType == 'url' ? link : null"
    :target="linkType == 'url' ? '_blank' : ''"
    @click="clicked(link)"
    v-bind="$attrs"
  >
    {{ text }}
  </v-btn>
</template>

<script>
export default {
  name: 'LinkButton',
  props: {
    link: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },
  computed: {
    linkType() {
      let linkArr = this.link.split('/')

      if (linkArr[0] == 'https:' || linkArr[0] == 'http:') {
        return 'url'
      }

      if (linkArr[0][0] == '#') {
        return 'section'
      }

      if (!linkArr[0] && linkArr[1]) {
        if (linkArr[1][0] == '#') {
          return 'section'
        } else {
          return 'page'
        }
      }

      return 'page'
    }
  },
  methods: {
    clicked(link) {
      if (
        this.linkType == 'section' &&
        document.getElementById(link.replace('#', '').replace('/', ''))
      ) {
        this.$vuetify.goTo(link, {
          offset: this.$store.state.section.stickyHeader.height
        })
      }
    }
  }
}
</script>
